enum AppsflyerException {
  General = 'AppsFlyerException',
}

export const AppsflyerExceptionMessage = {
  [AppsflyerException.General]: 'There was an error fetching the report.',
};

export default AppsflyerException;
